import { defineStore } from 'pinia';

import * as state from './api.state';
import * as getters from './api.getters';
import * as actions from './api.actions';

export const useApiStore = defineStore('api', () => ({
  ...state,
  ...getters,
  ...actions
}));
